import React, { useEffect } from "react";
import Header from "../Layout/Header";
import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
  TextField,
  IconButton,
} from "@material-ui/core";

import Footer from "../Layout/Footer";
import { gpColors } from "../../constants/colors";
import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Pagination } from "@material-ui/lab";
import usePagination from "../Filters/Pegination";
import oilfilter from "../../Images/oilFilter.jpg";
import SearchOutlined from "@material-ui/icons/SearchOutlined";
import { Helmet } from "react-helmet";
import _ from "lodash";
import img2 from '../../Images/img2.jpg'
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    padding: "30px",
    position: "relative",
    marginTop: "75px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "105px",
    },
  },
  filterHeader: {
    fontWeight: 900,
    fontSize: "20px",
    height: "53px",
    background: "#36404b",
    margin: "0px",
    lineHeight: "58px",
    letterSpacing: "1px",
    textAlign: "center",
    color: "#fff",
    position: "relative",
    width: "260px",
    marginBottom: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:before": {
      content: "''",
      left: "-20px",
      borderStyle: "solid",
      borderWidth: "0 0 53px 20px",
      borderColor: `transparent transparent ${gpColors.logoBrown} transparent`,
      position: "absolute",
    },
    "&:after": {
      content: "''",
      right: "-20px",
      borderStyle: "solid",
      borderWidth: "53px 20px 0 0",
      borderColor: `${gpColors.logoBrown} transparent transparent transparent`,
      position: "absolute",
    },
  },
  gridList: {
    borderBottom: "1px solid #ddd",
    paddingLeft: "10px",
    paddingRight: "5px",
    direction: "column",
    display: "flex",
    alignItems: "center",
  },
  img: {
    height: "100%",
    width: "65%",
    [theme.breakpoints.only("sm")]: {
      width: "30%",
    },
  },
  gridWrapper: {
    height: 195,
    width: "80%",
    borderLeft: "1px solid #ddd",
    borderRight: "1px solid #ddd",
    borderTop: "1px solid #ddd",
    //mobile view
    [theme.breakpoints.only("sm")]: {
      width: "100%",
      height: 230,
    },
    [theme.breakpoints.only("xs")]: {
      width: "100%",
      height: 230,
    },
  },
  filterContent: {
    fontSize: "16px",
    lineHeight: 2,
    textAlign: "justify",
    marginLeft: "50px",
    marginRight: "50px",
    [theme.breakpoints.down("md")]: {
      marginLeft: "0px",
      marginRight: "0px",
    },
  },
  imgBox: {
    width: "30%",
    height: 195,
    //mobile view
    [theme.breakpoints.only("xs")]: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      height: "100%",
    },
    // ipad view
    [theme.breakpoints.only("sm")]: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      height: "100%",
    },
  },
  elementContainer: {
    width: "100%",
    marginBottom: "10px",
    //mobile view
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
    //desktop view
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  changeRowColor: {
    // backgroundColor: "#ebecf0",
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  loaderContainer: {
    textAlign: "center",
    color: "#BE0A00",
    alignItems: "center",
    backgroundColor: "",
    display: "flex",
    justifyContent: "center",
    height: "20vh",
  },
}));

const Blog1 = () => {
  const classes = useStyles();

  const [apiData, setApiData] = useState([])
  const [oilFilterData, setOilFilterData] = useState([]);
  const [loader, setLoader] = useState(false);

  const [FilterKey, setFilterKey] = useState('')
  const [showMsg, setMsg] = useState()

  useEffect(() => {
    // console.log("rendered");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    getOilFilterDetails();

  }, []);
  // console.log(oilFilterData);

  const getOilFilterDetails = async () => {
    setLoader(true);
    try {
      const resp = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/getProducts/${1}`,
        {
          method: "GET",
          headers: {
            // // "ngrok-skip-browser-warning": "true",
          },
        }
      );
      const data = await resp.json();
      setApiData(data)
      setOilFilterData(data)

      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  };
  // for pegination set pegination count and data
  let [page, setPage] = useState(1);
  const PER_PAGE = 10;

  const count = Math.ceil(oilFilterData.length / PER_PAGE);
  let _DATA = usePagination(oilFilterData, PER_PAGE);
  // console.log("_DATA", _DATA.currentData());

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        {/* <title>My Title</title> */}
        <meta name="keywords" content="" />
        <meta
          name="description"
          content="Experience exceptional oil filtration with our automotive oil filters. Engineered for maximum efficiency and durability, our oil filters protect your engine from harmful contaminants. Trust our ISO-certified manufacturing and stringent quality control to keep your engine running smoothly. Explore our oil filter range now."
        />
      </Helmet>
      <Header />

      <Container>
        <div className={classes.container}>
          <div>
            <div
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <h1>Comparing Different Engine Air Filter Materials: Which One is Right for You?</h1>
            </div>

            <div className={classes.filterContent}>
              {/* {'/home/sarika/Documents/GitHub/GuardPlus/src/Images/airFilter.jpg'} */}
              <img src={img2} alt={'Image uploading'} height='100%' width='100%' />
              <p>
                {" "}
                The engine air filter is a critical component of your vehicle's engine system.
                Its primary function is to prevent harmful particles, dirt, and debris from entering the engine, ensuring optimal performance and longevity.
                When it comes to selecting the right engine air filter, understanding the different materials available is essential.
                In this blog post, we will compare various engine air filter materials and help you determine which one suits your needs best.
              </p>
              <p>
                {" "}
                1. Paper Filters :<br/>
                Paper filters are the most common and widely used engine air filters.
                They are composed of a pleated paper material that effectively traps dust, pollen, and other larger particles.
                Paper filters provide good filtration efficiency and are generally affordable.
                They may need more frequent replacements compared to some other materials and may not perform as well in extreme conditions.
              </p>
              <p>
                2. Cotton Gauze Filters:<br/>
                Cotton gauze filters are constructed using layers of cotton material.
                They offer excellent filtration capabilities, trapping even smaller particles and providing improved airflow compared to paper filters.
                Cotton gauze filters can be washed and re-oiled, making them reusable and cost-effective over time.
                They require regular maintenance and may have a higher upfront cost.
              </p>
              <p>
                3. Foam Filters:<br/>
                Foam filters are made of porous polyurethane foam.
                They are known for their exceptional ability to trap dust and dirt particles while allowing good airflow.
                Foam filters are commonly used in off-road and high-performance vehicles.
                They can be cleaned and re-oiled, similar to cotton gauze filters.
                Foam filters may require more frequent cleaning and maintenance due to their higher dirt-holding capacity.
              </p>
              <p>
                4. Synthetic Filters:<br/>
                Synthetic filters are constructed using synthetic materials like polyester or polypropylene.
                They offer improved filtration efficiency compared to paper filters, effectively capturing smaller particles.
                Synthetic filters are also known for their durability and resistance to moisture and chemicals.
                They provide reliable performance under various driving conditions. Synthetic filters may have a higher cost than paper filters.
              </p>
              <p>
                5. Carbon-Infused Filters:<br/>
                Carbon-infused filters combine filtration efficiency with odor and gas absorption capabilities.
                They feature a layer of activated carbon, which helps remove unpleasant odors, gasses, and volatile organic compounds (VOCs) from the incoming air.
                Carbon-infused filters are beneficial for individuals driving in areas with high pollution levels or dealing with specific odor concerns.
                They may have a shorter lifespan and be more expensive than other options.
              </p>
              <br/><br/>
              <p>
                <b>Conclusion</b>:<br />
                Choosing the right engine air filter material depends on several factors such as your driving conditions, vehicle requirements, and personal preferences.
                Paper filters offer a balance between affordability and performance.
                Cotton gauze filters provide improved filtration and can be reused, but require regular maintenance.
                Foam filters are ideal for off-road or high-performance applications but need frequent cleaning.
                Synthetic filters offer durability and enhanced filtration efficiency.
                Carbon-infused filters excel at odor and gas absorption.
                Consider your specific needs, consult your vehicle's manufacturer recommendations, and select the engine air filter material that best suits your requirements, ensuring optimal engine performance and longevity.
              </p>
            </div>
            <div
              style={{
                width: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                fontSize: '18px'
              }}
            >
              
            </div>

          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};
export default Blog1;
